import {Backdrop, CircularProgress} from '@mui/material'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../setup'

const LoadingOverlay = () => {
  const [open, setOpen] = useState(false)
  const reduxUserState: any = useSelector((state: RootState) => state.component)
  const backdropState = reduxUserState.backdrop

  useEffect(() => {
    if (backdropState.show !== null) {
      setOpen(backdropState.show)
    }
  }, [backdropState])

  return (
    <Backdrop sx={{color: '#fff', zIndex: '11111'}} open={open}>
      <CircularProgress color='inherit' />
    </Backdrop>
  )
}

export {LoadingOverlay}
